import { ShopChannelType } from './shop-channel-rules'

/** Shop desired shipping date days offset for each channel */
export const DESIRED_PRODUCT_EARLIEST_SHIPPING_DAYS = 3
export const DESIRED_SYSTEM_CONFIGURATOR_EARLIEST_SHIPPING_DAYS = 8

export const DESIRED_INTERNAL_CH_PRODUCT_EARLIEST_SHIPPING_DAYS = 28
export const DESIRED_INTERNAL_CH_SYSTEM_CONFIGURATOR_EARLIEST_SHIPPING_DAYS = 28

export const DESIRED_INTERNAL_FLOW_PRODUCT_EARLIEST_SHIPPING_DAYS = 14
export const DESIRED_INTERNAL_FLOW_SYSTEM_CONFIGURATOR_EARLIEST_SHIPPING_DAYS = 14

export const DESIRED_INTERNAL_NL_PRODUCT_EARLIEST_SHIPPING_DAYS = 14
export const DESIRED_INTERNAL_NL_SYSTEM_CONFIGURATOR_EARLIEST_SHIPPING_DAYS = 14

export const DESIRED_QNTM_CH_EARLIEST_SHIPPING_DAYS = 42
export const DESIRED_QNTM_NL_EARLIEST_SHIPPING_DAYS = 28
export const DESIRED_QNTM_FLOW_EARLIEST_SHIPPING_DAYS = 28
export const DESIRED_QNTM_DEFAULT_EARLIEST_SHIPPING_DAYS = 14

export const SHOP_CHANNEL_SHIPPING_DAYS: Record<ShopChannelType, { product: number; systemConfigurator: number; qntm: number }> = {
  [ShopChannelType.ShopE3dc]: {
    product: DESIRED_PRODUCT_EARLIEST_SHIPPING_DAYS,
    systemConfigurator: DESIRED_SYSTEM_CONFIGURATOR_EARLIEST_SHIPPING_DAYS,
    qntm: DESIRED_QNTM_DEFAULT_EARLIEST_SHIPPING_DAYS,
  },
  [ShopChannelType.ShopInternalCh]: {
    product: DESIRED_INTERNAL_CH_PRODUCT_EARLIEST_SHIPPING_DAYS,
    systemConfigurator: DESIRED_INTERNAL_CH_SYSTEM_CONFIGURATOR_EARLIEST_SHIPPING_DAYS,
    qntm: DESIRED_QNTM_CH_EARLIEST_SHIPPING_DAYS,
  },
  [ShopChannelType.ShopInternalFlow]: {
    product: DESIRED_INTERNAL_FLOW_PRODUCT_EARLIEST_SHIPPING_DAYS,
    systemConfigurator: DESIRED_INTERNAL_FLOW_SYSTEM_CONFIGURATOR_EARLIEST_SHIPPING_DAYS,
    qntm: DESIRED_QNTM_FLOW_EARLIEST_SHIPPING_DAYS,
  },
  [ShopChannelType.ShopInternalNL]: {
    product: DESIRED_INTERNAL_NL_PRODUCT_EARLIEST_SHIPPING_DAYS,
    systemConfigurator: DESIRED_INTERNAL_NL_SYSTEM_CONFIGURATOR_EARLIEST_SHIPPING_DAYS,
    qntm: DESIRED_QNTM_NL_EARLIEST_SHIPPING_DAYS,
  },
}
